import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'decimalTime', pure: true })
export class FormatDecimalTimePipe implements PipeTransform {
  transform(value: number) {
    const hours = value / 60 / 60;
    return hours.toFixed(2);
  }
}
